var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfCircles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 366,
    height: 400,
    viewBox: "0 0 366 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-36 400c111.01 0 201-89.546 201-200.002C165 89.543 75.022 0-36 0v400zM165 400c111.009 0 201-89.546 201-200.002C366 89.543 276.022 0 165 0v400z",
    fill: "#fff"
  })));
}
export default SvgHalfCircles;